import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api/client';
import { useToast } from '@/components/ui/toast';

export type TimelineLinkType = 'Deal' | 'Investment';

export interface TimelineItem {
  kind: string;
  type: string;
  occurredAtUtc: string;
  actorUserId: string | null;
  summary: string;
  detail: string | null;
  comment: string | null;
}

export const timelineKey = (linkType: TimelineLinkType, linkId: string) => ['timeline', linkType, linkId] as const;

export function useTimeline(linkType: TimelineLinkType, linkId: string | null) {
  return useQuery({
    queryKey: timelineKey(linkType, linkId ?? ''),
    enabled: !!linkId,
    queryFn: () => apiFetch<TimelineItem[]>(`/api/timeline?linkType=${linkType}&linkId=${linkId}`),
  });
}

export function useAddComment(linkType: TimelineLinkType, linkId: string) {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (text: string) =>
      apiFetch<TimelineItem>('/api/events', { method: 'POST', body: { linkType, linkId, text } }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: timelineKey(linkType, linkId) });
    },
    onError: () => toast('Não foi possível adicionar o comentário.', 'danger'),
  });
}
